var ArrayUtils = (function () {
    function ArrayUtils() {
    }
    ArrayUtils.prototype.filterMany = function (a, filters) {
        filters.forEach(function (filter) {
            a = a.filter(function (item) {
                return filter(item);
            });
        });
        return a;
    };
    ArrayUtils.prototype.sortMany = function (a, sorts) {
        sorts.forEach(function (sortFunc) {
            a = a.sort(function (a, b) {
                return sortFunc(a, b);
            });
        });
        return a;
    };
    return ArrayUtils;
}());
export default ArrayUtils;
export var arrayUtils = new ArrayUtils();



//////////////////
// WEBPACK FOOTER
// ./src/utils/ArrayUtils.ts
// module id = null
// module chunks = 